import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const textFilterLabelMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.textFilterLabel',
  defaultMessage: 'Texto',
});

const textFilterClearButtonMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.textFilterClearButton',
  defaultMessage: 'Limpiar búsqueda',
});

export interface LiveTopicsTextFilterProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Free-text input used to fuzzy-search topics by title, summary, key points and category.
 */
export function LiveTopicsTextFilter({ value, onChange }: LiveTopicsTextFilterProps) {
  const { $t } = useIntl();
  const hasValue = value.trim() !== '';

  return (
    <TextField
      size="small"
      label={$t(textFilterLabelMessage)}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      InputProps={{
        endAdornment: hasValue ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              title={$t(textFilterClearButtonMessage)}
              onClick={() => onChange('')}
            >
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
      sx={{ width: '100%' }}
    />
  );
}
